var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.tests),function(item,index){return _c('div',{key:index},[_c('Card',{attrs:{"item":item.evaluation},on:{"click":function($event){return _vm.gotoDetail(item.id)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }